// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const LoviztvColors: ColorType = {
  ...colorPalette,
  grayText: colorPalette.grayLabel,
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#ED1651',
  secondary: '#ED1651',
  errorRed: '#CF6679',
}

export const darkTheme = {
  colors: LoviztvColors,
  background: {
    primary: '#121212',
    secondary: '#222222',
    highlight: LoviztvColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: LoviztvColors.primaryGray,
    secondary: LoviztvColors.secondaryGray,
    disabled: LoviztvColors.grayText,
    link: LoviztvColors.secondaryGray,
    hint: LoviztvColors.white,
    highlight: LoviztvColors.secondary,
    gray: LoviztvColors.primaryGray,
    seeAll: LoviztvColors.secondaryGray,
    primaryContrast: LoviztvColors.white,
  },
  border: {
    primary: LoviztvColors.primaryGray,
    gray: LoviztvColors.secondaryGray,
  },
  filter: {
    primary: LoviztvColors.primaryGray,
    secondary: LoviztvColors.secondaryGray,
    disabled: LoviztvColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: LoviztvColors.dark,
    color: LoviztvColors.white,
    border: LoviztvColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: LoviztvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: LoviztvColors.dark,
        selected: LoviztvColors.dark,
        progress: rgba(LoviztvColors.primary, 0.3),
        past: rgba(LoviztvColors.primary, 0.3),
        pastSelected: LoviztvColors.dark,
        pastHover: LoviztvColors.dark,
        empty: '#555555',
        emptyProgress: rgba(LoviztvColors.primary, 0.2),
      },
      text: {
        empty: LoviztvColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: LoviztvColors.white,
    subTitle: LoviztvColors.secondaryGray,
    bg: LoviztvColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
